export default __webpack_public_path__ + "94ec58d9efe81e066e22413d229e3d9d.jpg";